export default function (context) {
  const width = window.innerWidth
  if (width < 992) {
    context.app.$util.setIsOpen(false)
  }
  $('body').removeClass('modal-open active');
  $('.modal-backdrop').remove();
}